import type { ScreenSize } from ".";

export const isScreenSize = (value: string): value is ScreenSize =>
  ["desktop", "tablet", "mobile"].includes(value);
